module.exports = __webpack_public_path__ + "img/mes-feature-menutree.1ba52f67.png";